import React, {Fragment} from 'react';
import classNames from 'classnames';
import {connect} from 'react-redux';
import MainModal from './MainModal';
import {setContent} from '../../actions';
import ErrorBoundary from "../ErrorBoundary";
import Icon from "../form/Icon";
import {withRouter} from "react-router-dom";
import {Helmet} from "react-helmet";
import {componentMapping} from "../../config/components";

class MainContent extends React.Component {

    render() {
        let componentMappings = this.props.componentMappings || componentMapping({prefix: window.envBooqadmin.componentMappings});
        let props = this.props.content.props && this.props.content.props;
        const section = this.props.content.section && this.props.content.section;
        if(this.setContent) {
            this.setContent.canceled = true;
        }
        const setContent = {
            setContent: this.props.setContent,
            canceled: false
        };
        setContent.func = function () {
            if(!this.canceled) {
                const args = [...Array.prototype.slice.call(arguments)];
                return this.setContent.apply(null, args);
            }
        }.bind(setContent);
        this.setContent = setContent;
        let Content = null;
        if (this.props.content.content) {
            if (componentMappings[this.props.content.content]) {
                Content = componentMappings[this.props.content.content];
                Content = <Content
                    {...props}
                    params={props}
                    setContent={this.setContent.func}
                    section={section}
                />;
            }
        }
        if (!Content && this.props.content.content) {
            Content = <div className="error-page">
                <h2 className="headline">404</h2>

                <div className="error-content">
                    <h3>Hiba.</h3>

                    <p>
                        Az oldal nem található.<br/>
                        <a
                            href="#"
                            onClick={(e) => {
                                e && e.preventDefault();
                                this.props.history.goBack();
                            }}
                        >
                            Vissza
                        </a>
                    </p>

                </div>
            </div>;
        } else if (!Content) {
            if (componentMappings.default) {
                Content = componentMappings.default;
                Content = <Content
                    {...props}
                    params={props}
                    setContent={this.setContent.func}
                    section={section}
                />;
            }
        }
        return (
            <div className="content-wrapper" id="maincontent">
                {(section.heading || (section.breadcrumbs && section.breadcrumbs.length)) ? <section className="content-header">
                    {section && section.heading && <Helmet>
                        <title>{window.envBooqadmin.title} - {section.heading}</title>
                    </Helmet>}
                    <h1>{section.heading}</h1>
                    {
                        section.breadcrumbs && section.breadcrumbs.length ?
                            <ol className="breadcrumb">
                                {section.breadcrumbs.map(
                                    (breadcrumb) => {
                                        return <li className={classNames({active: breadcrumb.active})}>
                                            <a href={ breadcrumb.link || "#" }>
                                                {breadcrumb.icon ? <Icon lib="fa" name={breadcrumb.icon } /> : null}
                                                {breadcrumb.text}
                                            </a>
                                        </li>;
                                    }
                                )}
                            </ol> : null
                    }
                </section> : null}
                <section className="content">
                    <ErrorBoundary>
                        {Content}
                    </ErrorBoundary>
                    <MainModal />
                    <div className="clearfix"/>
                </section>
            </div>
        );
    }
}

export default withRouter(connect((state) =>{
    return {
        content: state.app.template.content
    };
}, {setContent})(MainContent));